import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Card } from "reactstrap";
import ApprovalComponent from "./approvalComponent";
import DispatchAside from "./dispatchAside";

function ShowGRNPendingDetailsWrapper() {
  const { id }: any = useParams();
  const location = useLocation();

  const [sm, setSm] = useState(false);
  const [hideAside, setHideAside] = useState(true);

  const previousPath =
    location.state?.previousPath || "/pending-approvals-grn-list";

  useEffect(() => {
    if (location.state?.hideAside !== undefined) {
      setHideAside(location.state.hideAside);
    }
  }, [location.state]);

  return (
    <>
      <Head title="Material Invoice" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {!hideAside && (
              <div
                className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                  sm ? "content-active" : ""
                }`}
              >
                <DispatchAside updateSm={setSm} sm={sm} />
              </div>
            )}

            <ApprovalComponent
              dispatchNumber={id}
              previousPath={previousPath}
            />
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ShowGRNPendingDetailsWrapper;